export var PromotionCardType;
(function (PromotionCardType) {
    PromotionCardType["DEFAULT"] = "DEFAULT";
    PromotionCardType["DASHBOARD"] = "DASHBOARD";
    PromotionCardType["DASHBOARD_INVITE_AND_EARN"] = "DASHBOARD_INVITE_AND_EARN";
})(PromotionCardType || (PromotionCardType = {}));
export var ViewType;
(function (ViewType) {
    ViewType["WEB"] = "WEB";
    ViewType["MOBILE"] = "MOBILE";
})(ViewType || (ViewType = {}));
